/**
 * Termo de Uso e Responsabilidade exibido no primeiro acesso ao portal.
 *
 * A versão precisa bater com TERMS_VERSION do backend
 * (`backend/src/config/cameraTerms.ts`) — é ela que vai gravada no aceite.
 * Ao publicar um texto novo, suba a versão nos dois lugares: todo mundo que
 * aceitou a anterior verá a tela de aceite de novo.
 *
 * Formato do texto (lido pelo renderizador do TermsGate):
 *   "1. TÍTULO"  → título de seção
 *   "- item"     → item de lista
 *   "☐ ..."      → destaque das opções de aceite
 *   resto        → parágrafo
 */
export const TERMS_VERSION = "1.0";
export const TERMS_PUBLISHED_AT = "19/08/2026";
export const TERMS_TITLE = "TERMO DE USO E RESPONSABILIDADE";
export const TERMS_SUBTITLE =
  "SERVIÇO DE ARMAZENAMENTO E VISUALIZAÇÃO DE CÂMERAS EM NUVEM";

export const TERMS_TEXT = `1. OBJETO

O presente Termo de Uso e Responsabilidade estabelece as condições para utilização do serviço de armazenamento, gravação e visualização de imagens de câmeras em nuvem, disponibilizado pela WIP TELECOM MULTIMIDIA EIRELI.

O serviço permite ao cliente cadastrar e utilizar câmeras compatíveis, realizar sua operação e visualizar e armazenar as respectivas gravações em ambiente de nuvem, de acordo com a quantidade de armazenamento contratada.

O serviço será disponibilizado de acordo com o plano, capacidade de armazenamento e quantidade de câmeras contratados pelo cliente.

2. RESPONSABILIDADE DO CLIENTE PELAS CÂMERAS

O cliente será integralmente responsável pelo cadastramento, configuração, operação, funcionamento e manutenção das câmeras utilizadas em seu serviço.

Compete exclusivamente ao cliente:

- cadastrar as câmeras no sistema;
- informar corretamente os dados necessários para o cadastramento;
- configurar as câmeras de acordo com suas necessidades;
- manter as câmeras em funcionamento;
- manter as câmeras devidamente conectadas à internet;
- verificar o correto funcionamento das câmeras;
- realizar manutenção, substituição ou reparo das câmeras quando necessário;
- acompanhar o status das câmeras no sistema;
- verificar se as gravações estão sendo realizadas corretamente;
- administrar quais câmeras permanecerão cadastradas;
- remover ou substituir câmeras quando necessário;
- manter atualizada a quantidade de câmeras contratadas.

A WIP TELECOM MULTIMIDIA EIRELI disponibiliza a infraestrutura do serviço de armazenamento e visualização em nuvem, não sendo responsável pela instalação física, manutenção, funcionamento ou integridade dos equipamentos de câmera pertencentes ao cliente, salvo quando houver contratação específica de serviço adicional para essa finalidade.

3. RESPONSABILIDADE PELA OPERAÇÃO

A operação e administração das câmeras são de responsabilidade exclusiva do cliente.

O cliente deverá acompanhar regularmente o funcionamento de suas câmeras e verificar se as imagens estão sendo corretamente transmitidas e armazenadas.

A simples disponibilização do serviço de armazenamento em nuvem não significa garantia de que determinada câmera esteja funcionando, conectada ou transmitindo imagens.

Problemas relacionados a:

- falta de energia elétrica no local da câmera;
- falha ou ausência de conexão com a internet;
- defeito da câmera;
- configuração incorreta;
- desligamento do equipamento;
- falha de alimentação elétrica;
- problemas de rede local;
- problemas de infraestrutura do cliente;
- alteração indevida das configurações;

poderão impedir a gravação ou transmissão das imagens e deverão ser verificados pelo próprio cliente ou por responsável por ele contratado.

4. ARMAZENAMENTO EM NUVEM

O armazenamento das imagens será realizado de acordo com a quantidade de espaço em nuvem contratada pelo cliente.

O cliente é responsável por acompanhar e administrar a utilização do espaço contratado, devendo manter capacidade suficiente para a finalidade desejada.

A quantidade de armazenamento disponível será aquela correspondente ao plano contratado e/ou posteriormente alterado pelo cliente.

O cliente poderá contratar capacidade adicional, quando disponível, de acordo com as condições comerciais vigentes.

5. RESPONSABILIDADE PELO LIMITE DE ARMAZENAMENTO

O cliente declara estar ciente de que o espaço de armazenamento em nuvem é limitado à capacidade contratada.

É responsabilidade exclusiva do cliente acompanhar a utilização do espaço disponível e contratar capacidade adicional quando entender necessário.

O cliente reconhece que a quantidade de dias de gravação disponíveis poderá variar de acordo com diversos fatores, incluindo:

- quantidade de câmeras cadastradas;
- resolução das imagens;
- qualidade das gravações;
- quantidade de frames por segundo;
- configuração de gravação;
- movimentação registrada pelas câmeras;
- quantidade de dados gerados;
- tempo de funcionamento das câmeras;
- capacidade de armazenamento contratada.

Dessa forma, a capacidade contratada não representa necessariamente uma quantidade fixa de dias de armazenamento, podendo o período de retenção variar conforme o volume de dados gerado pelas câmeras.

6. EXCLUSÃO AUTOMÁTICA DAS GRAVAÇÕES

O cliente declara estar ciente de que as imagens armazenadas em nuvem estão sujeitas à exclusão automática, conforme a utilização do espaço de armazenamento contratado e as regras técnicas do serviço.

Quando o espaço contratado for utilizado, as gravações mais antigas poderão ser automaticamente sobrescritas ou excluídas para permitir o armazenamento de novas gravações.

A exclusão automática das imagens faz parte do funcionamento normal do serviço e não constitui falha ou obrigação da WIP TELECOM MULTIMIDIA EIRELI de manter indefinidamente as gravações.

7. RESPONSABILIDADE PELO DOWNLOAD E PRESERVAÇÃO DAS IMAGENS

É de exclusiva responsabilidade do cliente identificar as imagens que considere importantes e realizar o respectivo download/baixamento e armazenamento em local de sua responsabilidade antes que essas imagens sejam automaticamente excluídas ou sobrescritas pelo sistema.

A WIP TELECOM MULTIMIDIA EIRELI não será responsável pela recuperação de imagens que tenham sido automaticamente excluídas ou sobrescritas em razão do limite de armazenamento contratado, quando não houver cópia previamente realizada pelo cliente.

O cliente deverá realizar o download das imagens que considere necessárias para:

- registros de ocorrências;
- segurança;
- comprovação de fatos;
- utilização administrativa;
- utilização judicial ou extrajudicial;
- fornecimento a autoridades;
- qualquer outra finalidade que julgar necessária.

Após o download, a guarda, integridade, segurança e utilização dessas imagens passarão a ser de responsabilidade do cliente.

8. NÃO GARANTIA DE PRESERVAÇÃO INDEFINIDA

A contratação do serviço de armazenamento em nuvem não representa garantia de preservação permanente das imagens.

As imagens permanecerão disponíveis enquanto houver espaço de armazenamento contratado e de acordo com o funcionamento e as regras técnicas do serviço.

O cliente é o único responsável por identificar e preservar, por meio de download, qualquer imagem que necessite manter por período superior ao tempo de retenção proporcionado pelo espaço contratado.

A WIP TELECOM MULTIMIDIA EIRELI não terá obrigação de recuperar imagens que tenham sido regularmente excluídas ou sobrescritas pelo sistema em razão do limite de armazenamento contratado.

9. CANCELAMENTO, REDUÇÃO OU ALTERAÇÃO DO ESPAÇO CONTRATADO

O cliente reconhece que alterações na quantidade de armazenamento contratado poderão alterar diretamente o período de retenção das imagens.

Em caso de:

- redução da capacidade contratada;
- cancelamento do serviço;
- alteração do plano;
- redução da quantidade de câmeras;
- encerramento da conta;

o cliente será responsável por realizar previamente o download de todas as imagens que desejar preservar.

Após a redução, alteração ou encerramento do serviço, as imagens poderão deixar de estar disponíveis conforme as regras técnicas e comerciais aplicáveis ao serviço.

10. RESPONSABILIDADE PELO CADASTRAMENTO DAS CÂMERAS

O cliente será responsável por manter correta e atualizada a relação de câmeras cadastradas no sistema.

A inclusão de novas câmeras poderá aumentar significativamente o volume de dados armazenados e, consequentemente, reduzir o período de retenção das gravações.

O cliente deverá avaliar a quantidade de câmeras utilizadas em conjunto com a capacidade de armazenamento contratada.

A WIP TELECOM MULTIMIDIA EIRELI não será responsável por eventual redução do período de retenção causada pelo aumento da quantidade de câmeras ou do volume de dados gerados pelo cliente.

11. ACESSO E CREDENCIAIS

O cliente será responsável pela guarda e utilização de seus usuários, senhas, links, aplicativos e demais credenciais utilizadas para acesso ao sistema.

As credenciais são pessoais e não deverão ser compartilhadas com pessoas não autorizadas.

O cliente será responsável por administrar os usuários que tenham autorização para acessar suas câmeras e imagens.

12. COMPARTILHAMENTO E COMERCIALIZAÇÃO DAS IMAGENS

As imagens armazenadas no sistema são de responsabilidade do cliente quanto à sua utilização, tratamento e divulgação.

É proibido utilizar o sistema para fins ilícitos ou para violar direitos de terceiros.

O cliente deverá observar a legislação aplicável antes de compartilhar, divulgar ou fornecer imagens a terceiros.

É expressamente proibida a comercialização, venda, distribuição ou exploração econômica das imagens obtidas por meio do sistema quando tal utilização não estiver amparada por autorização ou fundamento legal.

O cliente também será responsável por orientar e controlar os usuários aos quais conceder acesso às câmeras e às imagens.

13. PROTEÇÃO DE DADOS – LGPD

As imagens captadas pelas câmeras podem conter dados pessoais e informações que permitam a identificação de pessoas.

O tratamento dessas informações deverá observar a Lei nº 13.709/2018 – Lei Geral de Proteção de Dados Pessoais (LGPD) e demais normas aplicáveis.

O cliente será responsável pela utilização das câmeras e pelas finalidades para as quais realiza a captação e o armazenamento das imagens.

O cliente deverá observar os princípios e obrigações previstos na legislação aplicável, especialmente quanto à finalidade, necessidade, segurança, transparência e proteção dos dados pessoais.

Quando aplicável, o cliente deverá possuir base legal adequada para a captação, armazenamento, utilização e eventual compartilhamento das imagens.

A utilização das câmeras pelo cliente não deverá ocorrer de maneira a violar a privacidade, a intimidade, a honra ou a imagem de terceiros.

14. SEGURANÇA DAS IMAGENS

O cliente deverá adotar medidas adequadas para proteger suas credenciais e as imagens às quais possui acesso.

Após realizar o download das imagens, o cliente será responsável pela guarda, armazenamento, segurança e eventual compartilhamento dos arquivos.

A WIP TELECOM MULTIMIDIA EIRELI não será responsável pela utilização indevida de imagens que tenham sido baixadas pelo cliente e estejam sob sua guarda ou de terceiros autorizados por ele.

15. RESPONSABILIDADE PELA DISPONIBILIDADE DAS IMAGENS

A disponibilidade das imagens depende do correto funcionamento das câmeras, da conexão de rede, da transmissão dos dados e do armazenamento contratado.

A WIP TELECOM MULTIMIDIA EIRELI não será responsável por imagens que não tenham sido gravadas em razão de problemas relacionados aos equipamentos, conexão, energia elétrica, rede local ou configurações sob responsabilidade do cliente.

Da mesma forma, não será responsável pela perda de imagens que tenham sido automaticamente excluídas ou sobrescritas dentro das regras normais do armazenamento contratado.

16. MANUTENÇÃO E VERIFICAÇÃO DO SERVIÇO

É responsabilidade do cliente verificar periodicamente se suas câmeras estão funcionando e se as imagens estão sendo corretamente armazenadas.

Recomenda-se que o cliente realize verificações periódicas e, sempre que necessário, faça o download das imagens que considere importantes.

O cliente não deverá presumir que uma imagem permanecerá disponível indefinidamente no sistema.

17. SUSPENSÃO OU CANCELAMENTO

O acesso ao serviço poderá ser suspenso ou cancelado nas hipóteses previstas no contrato comercial, especialmente em caso de inadimplência, encerramento da contratação ou violação das condições de utilização.

O cliente deverá realizar previamente o download das imagens que desejar preservar antes do encerramento, redução ou suspensão do serviço.

18. RESPONSABILIDADE DO CLIENTE

O cliente declara estar ciente de que é o principal responsável:

- pelo cadastramento das câmeras;
- pela operação das câmeras;
- pela manutenção dos equipamentos;
- pela conexão das câmeras;
- pela verificação das gravações;
- pela quantidade de câmeras contratadas;
- pela capacidade de armazenamento contratada;
- pelo acompanhamento do espaço disponível;
- pela identificação das imagens que deseja preservar;
- pelo download das imagens antes da exclusão automática;
- pela guarda das imagens baixadas;
- pela administração dos usuários autorizados;
- pela utilização e eventual compartilhamento das imagens;
- pelo cumprimento da legislação aplicável, inclusive a LGPD.

19. ACEITE ELETRÔNICO

Ao acessar o sistema, o cliente declara que teve acesso integral a este Termo de Uso e Responsabilidade, leu seu conteúdo e está ciente de todas as condições nele estabelecidas.

Para prosseguir com a utilização do serviço, o cliente deverá selecionar uma das opções abaixo:

☐ CONCORDO COM TODOS OS TERMOS

Declaro que li, compreendi e concordo integralmente com todos os termos e condições deste documento.

Declaro estar ciente de que sou responsável pelo cadastramento, operação e manutenção das câmeras, pela quantidade de câmeras utilizadas, pela capacidade de armazenamento em nuvem contratada e pelo acompanhamento das imagens armazenadas.

Declaro também estar ciente de que é minha responsabilidade realizar o download e preservar as imagens que considerar necessárias antes que sejam automaticamente excluídas ou sobrescritas em razão do limite de armazenamento contratado.

Declaro ainda estar ciente das disposições relativas à proteção de dados, privacidade, utilização, compartilhamento e divulgação das imagens, nos termos da legislação aplicável e da Lei nº 13.709/2018 – Lei Geral de Proteção de Dados Pessoais (LGPD).

Ao selecionar "CONCORDO COM TODOS OS TERMOS", confirmo minha concordância integral com este Termo.

☐ NÃO CONCORDO COM OS TERMOS

Declaro que não concordo com os termos e condições estabelecidos neste documento.

A seleção de "NÃO CONCORDO COM OS TERMOS" impedirá o prosseguimento e a utilização do serviço de visualização e armazenamento de câmeras em nuvem.

20. REGISTRO DO ACEITE ELETRÔNICO

Para fins de segurança, auditoria e comprovação do aceite, o sistema poderá registrar automaticamente:

- identificação do cliente/usuário;
- data e hora do aceite;
- endereço IP utilizado;
- identificação da conta;
- versão do Termo aceita;
- opção selecionada pelo cliente;
- demais informações técnicas necessárias para comprovação do aceite.

Os registros deverão ser tratados de acordo com a legislação aplicável, especialmente a Lei nº 13.709/2018 – LGPD.`;
